module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fixed-sidebar",
    class: {
      'mini-navbar': _vm.config.minimize
    },
    attrs: {
      "id": "body"
    }
  }, [_c('div', {
    attrs: {
      "id": "wrapper"
    }
  }, [_c('Navigation'), _vm._v(" "), _c('div', {
    staticClass: "gray-bg",
    attrs: {
      "id": "page-wrapper"
    },
    on: {
      "click": _vm.blankClick
    }
  }, [_c('TopNavBar'), _vm._v(" "), _c('div', {
    staticClass: "mt10 pb40"
  }, [_c('div', {
    staticClass: "mb10"
  }, [_c('a', {
    staticClass: "mr10",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  })]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/by"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t首页\n\t\t\t\t\t\t")]), _vm._v(" "), _vm._l((_vm.$store.state.breadcrumbs), function(b) {
    return _c('span', [_c('span', [_vm._v("/")]), _vm._v(" "), (b.name !== _vm.$store.state.route.name) ? _c('router-link', {
      attrs: {
        "to": b
      }
    }, [_vm._v("\n                " + _vm._s(b.title) + "\n              ")]) : _vm._e(), _vm._v(" "), (b.name === _vm.$store.state.route.name) ? _c('span', [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(b.title) + "\n\t\t\t\t\t\t\t")]) : _vm._e()], 1)
  })], 2), _vm._v(" "), _c('router-view')], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-33a1001c"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/backyard/Frame.vue
// module id = 970
// module chunks = 1